export const providers = [
  { label: 'Anthropic', value: 'anthropic' },
  { label: 'OpenAI', value: 'openai' },
  { label: 'AWS Bedrock', value: 'aws_bedrock' },
];

export const INTEGRATION_CLIENT_OPTIONS = [
  { value: 'axenita', label: 'Axenita' },
  { value: 'ineskis', label: 'Ineskis' },
  { value: 'aeskulap', label: 'Aeskulap' },
];

export const PAGE_SIZE = 50;

/** Max matches returned by searchable org/user typeaheads. */
export const SEARCH_OPTIONS_LIMIT = 50;

/** TTL for filter-option list caches used across pages (ms). Infinity = until mutation. */
export const FILTER_CACHE_TTL = {
  tools: Infinity,
  models: Infinity,
  organisations: 5 * 60 * 1000,
  users: 5 * 60 * 1000,
};

export const filterControlClassName =
  'w-56 min-w-56 max-w-56 shrink-0 px-4 py-2 border rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500';

